import Vue from 'vue'
import Vuex from 'vuex'
import { wishlistsUrl, giftBoughtUrl } from './api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    wishlists: [],
  },
  getters: {
    getWishlists: state => {
      return state.wishlists
    },
    getGift: (state, wishListIdx, giftIdx) => {
      return state.wishlists[wishListIdx].gifts[giftIdx]
    }
  },
  mutations: {
    SET_WISHLISTS(state, wishlists) {
      state.wishlists = wishlists
    },
    UPDATE_GIFTS_BOUGHT(state, {wishListIdx, giftIdx, newNum}) {
      state.wishlists[wishListIdx].gifts[giftIdx].bought = newNum
    },
  },
  actions: {
    async fetchWishLists ({commit}) {
      let response = await fetch(wishlistsUrl)
      let body = await response.json()
      if(response.ok) commit('SET_WISHLISTS', body)
    },
    async updateGiftBought ({commit}, {wishListIdx, giftIdx, newNum}) {
      if(newNum < 0) return
      let response = await fetch(giftBoughtUrl(wishListIdx, giftIdx), {
        method: 'PUT',
        body: JSON.stringify(newNum),
        headers: { 'Content-Type': 'application/json' }
      })
      if(response.ok) commit('UPDATE_GIFTS_BOUGHT', {wishListIdx, giftIdx, newNum})
    } 
  }
})
